// texto que se muestra en la ficha de un reloj cuando no tiene descripcion propia
export const DESCRIPCION_POR_DEFECTO = [
  "⌚ Diseño robusto y moderno",
  "💧 Resistentes al agua",
  "📦 Totalmente nuevos, con caja sellada",
  "⏱️ Cronómetro y temporizador",
  "💡 Luz LED incorporada",
  "💪 Resistentes, ideales para el día a día",
  "🏍️ Envíos en el día en Montevideo o retiro en persona",
  "🚚 Envíos a todo el país",
].join("\n");
